import React from "react";
import check from "../../images/checkIcon.png";
function Toast({ isOpen, message, duration = 4000, onClose }) {
  React.useEffect(() => {
    if (!isOpen) return;
    if (!onClose) return;
    const timer = setTimeout(onClose, duration);
    return () => clearTimeout(timer);
  }, [isOpen, duration, onClose]);

  if (!isOpen) return null;

  return (
    <div className="fixed left-1/2 bottom-[150px] z-50 -translate-x-1/2">
      <div className="flex items-center justify-center gap-4 bg-[#888888] rounded-[10px] px-6 py-5 min-w-[314px]">
        <img src={check} alt="check" className="w-6 h-6" />
        <span className="w-full text-[#EBEBEB] text-[13px] md:text-[15px] font-semibold leading-0">
          {message}
        </span>
      </div>
    </div>
  );
}

export default Toast;
